export default __webpack_public_path__ + "static/help_06_03-6-65d47599d9e80bd9d51ffd0b3d16a93a.png";